import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["resultArea"]

  // ボタンクリック時に呼ばれる
  toggleContent(e) {
    const button = e.currentTarget

    // 表示エリアの id はボタンごとに指定できる（data-event-content-area-id）。
    // カンマ区切りで複数エリアを指定可能（例: ナインピース取材のレポート画面は
    // 「ポスター」+「レポート本文」を 1 ボタンで縦積み表示する）。
    // 未指定の場合は event id から `result-area-${id}` を導出する。
    const areaIdsAttr = button.dataset.eventContentAreaId
    const areaIds = areaIdsAttr
      ? areaIdsAttr.split(",").map(s => s.trim()).filter(Boolean)
      : [`result-area-${button.dataset.eventContentEventIdValue}`]

    const areas = areaIds.map(id => document.getElementById(id)).filter(Boolean)
    if (areas.length === 0) return

    // 表示状態は先頭エリアで判定（複数指定時も表示・非表示は一括で揃える）
    const shouldShow = areas[0].style.display === "none" || areas[0].style.display === ""

    areas.forEach(area => {
      if (shouldShow) {
        if (area.dataset.loaded === "false") {
          const url = area.dataset.source
          this.fetchContent(url)
            .then(html => {
              area.innerHTML = html
              area.dataset.loaded = "true"
              area.style.display = "block"
            })
            .catch(err => console.error("Error fetchContent:", err))
        } else {
          area.style.display = "block"
        }
      } else {
        area.style.display = "none"
      }
    })
  }

  // Ajaxで指定 URL を GET し、HTML 文字列を返す
  fetchContent(url) {
    return fetch(url, { method: "GET" })
      .then(res => res.text())
  }
}
